import React from 'react';
import { View, StyleSheet } from 'react-native';
import { ShowMoreText } from '@/components/common/ShowMoreText';
import { useThemeColors, useThemedStyles } from '@/hooks/residents/useThemeColors';
import type { ThemeContextValue } from '@/hooks/residents/useThemeColors';
import { SVG_COMPONENTS } from '@/assets/admin';

interface BulletinDescriptionProps {
  text: string;
  expanded: boolean;
  onToggle: () => void;
}

export const BulletinDescription: React.FC<BulletinDescriptionProps> = ({ text, expanded, onToggle }) => {
  const { semantic } = useThemeColors();
  const styles = useThemedStyles(makeStyles);
  return (
    <View style={styles.descriptionContainer}>
      <ShowMoreText
        text={text}
        expanded={expanded}
        onToggle={onToggle}
        textStyle={styles.description}
        linkStyle={styles.showMoreText}
        rightIcon={(
          <View style={[styles.showMoreIcon, expanded && styles.showMoreIconRotated]}>
            <SVG_COMPONENTS.CHEVRON_DOWN width={16} height={16} color={semantic.text.link} />
          </View>
        )}
      />
    </View>
  );
};

const makeStyles = ({ semantic }: ThemeContextValue) => StyleSheet.create({
  descriptionContainer: {
    marginBottom: 8,
  },
  description: {
    fontSize: 14,
    color: semantic.text.primary,
    lineHeight: 20,
    marginBottom: 4,
  },
  showMoreText: {
    fontSize: 14,
    color: semantic.text.link,
    marginRight: 4,
  },
  showMoreIcon: {
    transform: [{ rotate: '0deg' }],
  },
  showMoreIconRotated: {
    transform: [{ rotate: '180deg' }],
  },
});

export default BulletinDescription;


